module.exports = __webpack_public_path__ + "static/media/c68f0a30-d33e-4435-92e5-d1149951a69a.1d91f64d.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/c68f0a30-d33e-4435-92e5-d1149951a69a.jpg
// module id = 851
// module chunks = 0